export const RULE_OPERATORS = {
  eq: { value: 'eq', label: 'Igual a' },
  neq: { value: 'neq', label: 'Diferente de' },
  gt: { value: 'gt', label: 'Mayor que' },
  gte: { value: 'gte', label: 'Mayor o igual que' },
  lt: { value: 'lt', label: 'Menor que' },
  lte: { value: 'lte', label: 'Menor o igual que' },
  in: { value: 'in', label: 'Incluido en' },
  not_in: { value: 'not_in', label: 'No incluido en' },
  between: { value: 'between', label: 'Entre' },
  contains: { value: 'contains', label: 'Contiene' },
};

export const OPERATORS_BY_FIELD_TYPE = {
  string: [
    RULE_OPERATORS.eq,
    RULE_OPERATORS.neq,
    RULE_OPERATORS.contains,
    RULE_OPERATORS.in,
    RULE_OPERATORS.not_in,
  ],

  integer: [
    RULE_OPERATORS.eq,
    RULE_OPERATORS.neq,
    RULE_OPERATORS.gt,
    RULE_OPERATORS.gte,
    RULE_OPERATORS.lt,
    RULE_OPERATORS.lte,
    RULE_OPERATORS.between,
    RULE_OPERATORS.in,
    RULE_OPERATORS.not_in,
  ],

  currency: [
    RULE_OPERATORS.eq,
    RULE_OPERATORS.neq,
    RULE_OPERATORS.gt,
    RULE_OPERATORS.gte,
    RULE_OPERATORS.lt,
    RULE_OPERATORS.lte,
    RULE_OPERATORS.between,
  ],

  boolean: [
    RULE_OPERATORS.eq,
    RULE_OPERATORS.neq,
  ],

  select: [
    RULE_OPERATORS.eq,
    RULE_OPERATORS.neq,
    RULE_OPERATORS.in,
    RULE_OPERATORS.not_in,
  ],
};
